import React from "react";
import { NavLink } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  EditBannerAPI,
  GetCategoryImage,
  GetBannerById,
  GetProductStatus,
  api_url,
  GetWedgetOptionwithbanner,
} from "../apiconfig/authService";
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";

function EditBanner(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;
  const setCategoryViewMessage = props.setMessage;


  const [mediaData, setMediaData] = useState({});
  const [editedMediaData, setEditedMediaData] = useState({});
  const { id } = useParams();
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const imageInputRef = React.createRef();
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [getwidgetoption, setGetwidgetoption] = useState();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetBannerById(
          id,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        const getallwidgetresponse = await GetWedgetOptionwithbanner();
        setMediaData(response.data);
        setEditedMediaData(response.data);
        setGetwidgetoption(getallwidgetresponse.data.items);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
       setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
         setLoading(false);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
         setLoading(false);
      }
    })();
  }, []);

  const handleTitleChange = (e) => {
    const temp = { ...editedMediaData };
    temp.title = e.target.value;
    setEditedMediaData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };
  const handleWidgetChange = (e) => {
    const selected = [...e.target.selectedOptions].map(
      (option) => option.value
    );
    setSelectedWidgets(selected);
  };

  const handleWidgetsChange = (selectedOptions) => {
    setSelectedWidgets(selectedOptions.map((option) => option.value));
  };
  const handleDiscardClick = async () => {
    // Reset the image input field
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  
    setNewImage(null);
    setSelectedWidgets(mediaData.widgets?.map((widget) => widget._id) || []);
  
    // Reset editedMediaData to the initial state (mediaData)
    setEditedMediaData({ ...mediaData });
    navigate("/banner");
  };
  
  const handleStatusChange = (e) => {
    const temp = { ...editedMediaData };
    temp.statusid = e.target.value;
    setEditedMediaData(temp);
  };
  const handleSerialNUmber = (e) => {
    const temp = { ...editedMediaData };
    temp.serialNumber = e.target.value;
    setEditedMediaData(temp);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!editedMediaData.title || !editedMediaData.title.trim()) {
        toast.error("Banner title is required!");
        return;
      }

      if (
        !editedMediaData.serialNumber ||
        editedMediaData.serialNumber === ""
      ) {
        toast.error("Serial Number is required!");
        return;
      }

      if (isNaN(editedMediaData.serialNumber)) {
        toast.error("Serial Number must be a number!");
        return;
      }

      if (!selectedWidgets || selectedWidgets.length === 0) {
        toast.error("At least one Widget is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("id", id);
    formData.append("title", editedMediaData.title);
    formData.append("statusid", editedMediaData.statusid);
    formData.append("serialNumber", editedMediaData.serialNumber);

    // Add each selected widget ID
    selectedWidgets.forEach((widgetId) => {
      formData.append("widgets[]", widgetId);
    });

    if (newImage) {
      formData.append("Image", newImage);
      formData.append("imagename", editedMediaData.image);
    }

    try {
      setEditLoading(true);
      response = await EditBannerAPI(
        id,
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Banner Updated Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/banner");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }
  };

  useEffect(() => {
    if (mediaData?.widgets) {
      setSelectedWidgets(mediaData.widgets.map((widget) => widget._id));
    }
  }, [mediaData]);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Banner</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/banner" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catName">Title</label>
                <input
                  type="text"
                  value={editedMediaData?.title || ""}
                  onChange={handleTitleChange}
                  className="form-control custom-input my-2"
                  id="catName"
                  placeholder=""
                />
              </div>

              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catImg">Image</label>
                <input
                  type="file"
                  ref={imageInputRef}
                  className="form-control custom-input my-2"
                  id="catImg"
                  onChange={handleImageChange}
                  placeholder=""
                />
                <img
                  width="30px"
                  height="30px"
                  src={`${api_url}/product/category/getCategoryImage/${editedMediaData?.image}`}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="floatingInput">Status</label>
                <select
                  className="form-select custom-input my-2"
                  onChange={handleStatusChange}
                  value={editedMediaData?.statusid}
                >
                  {statusData?.map((item, index) => (
                    <option value={item.statusid} key={index}>
                      {item.status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catName">Serial Number</label>
                <input
                  type="text"
                  value={editedMediaData?.serialNumber || ""}
                  onChange={handleSerialNUmber}
                  className="form-control custom-input my-2"
                  id="catName"
                  placeholder="Serial"
                />
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <label htmlFor="floatingInput">Widgets</label>
              <Select
                isMulti
                options={[
                  ...(editedMediaData.widgets || []).map((widget) => ({
                    value: widget._id,
                    label: widget.title,
                  })),
                  ...(getwidgetoption || []).map((widget) => ({
                    value: widget._id,
                    label: widget.title,
                  })),
                ]}
                value={
                  selectedWidgets
                    .map((widgetId) => {
                      // Find the widget in `editedMediaData.widgets` or `getwidgetoption`
                      const widget = [
                        ...(editedMediaData.widgets || []),
                        ...(getwidgetoption || []),
                      ].find((widget) => widget._id === widgetId);
                      return widget
                        ? { value: widget._id, label: widget.title }
                        : null;
                    })
                    .filter((option) => option !== null) || ""
                } // Ensure only non-null options are included
                onChange={(selectedOptions) => {
                  // Update the selectedWidgets with the IDs of selected options
                  setSelectedWidgets(
                    selectedOptions.map((option) => option.value)
                  );
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Widgets..."
              />
            </div>
            <div className="row">
              <div
                className="col-12 d-flex"
                style={{ height: "40px", width: "120px" }}
              >
                <button
                  type="submit"
                  onClick={handleDiscardClick}
                  disabled={editLoading}
                  style={{ height: "100%", width: "100%" }}
                  className="btn btn-danger save-btn text-uppercase"
                >
                  Discard
                </button>{" "}
                &nbsp;
                {editLoading ? (
                  <div
                    className="btn btn-primary loader-active save-btn"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={handleSubmitClick}
                    disabled={editLoading}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}
export default EditBanner;
